import React from 'react';
import { Divider } from 'components/atoms/Dividers/Divider';
import { classNames } from 'helpers/style/classNames';
import useStyle from './commandDetailLine.style';

export interface CommandDetailLineProps {
  title: string;
  text?: string;
  withDivider?: boolean;
  variant?: 'default' | 'recapCommande';
}

export const CommandDetailLine = ({
  title,
  text,
  withDivider = false,
  variant = 'default'
}: CommandDetailLineProps) => {
  const classes = useStyle();

  return (
    <div className={classNames([classes.root, classes[variant]])}>
      <span>{title}</span>
      <span className={classNames([classes.text, classes['text' + variant]])}>
        {text ? text : 'Pas de valeur'}
      </span>
      {withDivider && <Divider />}
    </div>
  );
};
